import { spacing } from './types'
import type { SpacingSize } from './types'
import type { CSSProperties, ReactNode } from 'react'

export interface StackProps {
  gap?: SpacingSize
  align?: CSSProperties['alignItems']
  style?: CSSProperties
  className?: string
  children?: ReactNode
}

/** Vertical flex column. Use instead of inline `display:flex, flexDirection:column`.
 *  Pass a named gap constant (e.g. gap="md") — see SpacingSize for the full scale. */
export function Stack({ gap, align, style, className, children }: StackProps) {
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: gap ? spacing[gap] : undefined,
        alignItems: align,
        ...style,
      }}
    >
      {children}
    </div>
  )
}
